// assets/contact-form.js

(function () {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initValidation);
  } else {
    initValidation();
  }

  function initValidation() {
    var form = document.querySelector('.contact-form');
    if (!form) {
      // console.log('Contact form not found');
      return;
    }

    // Get error messages from data attributes
    var generalErrorMessage = form.dataset.validationError || 'Please fix all errors before submitting.';

    // Create error message container for each field dynamically
    function createErrorContainer(field) {
      var fieldContainer = field.closest('.field');
      if (!fieldContainer) return;
      
      var existingError = fieldContainer.querySelector('.field-error-message');

      if (!existingError) {
        var errorDiv = document.createElement('div');
        errorDiv.className = 'field-error-message';
        errorDiv.style.display = 'none';
        fieldContainer.appendChild(errorDiv);
      }
    }

    // Validation functions with specific error messages
    function validateEmail(email) {
      if (!email || email.trim() === '') {
        return { valid: false, message: 'Email address is required' };
      }
      
      var trimmedEmail = email.trim();
      
      // Check for @ symbol
      if (trimmedEmail.indexOf('@') === -1) {
        return { valid: false, message: 'Email is missing the @ symbol' };
      }
      
      // Check for exactly one @ symbol
      var parts = trimmedEmail.split('@');
      if (parts.length !== 2) {
        return { valid: false, message: 'Email must contain exactly one @ symbol' };
      }
      
      var localPart = parts[0];
      var domainPart = parts[1];
      
      // Check local part
      if (localPart.length === 0) {
        return { valid: false, message: 'Email is missing the part before @' };
      }
      
      if (localPart.length > 64) {
        return { valid: false, message: 'Email local part is too long (maximum 64 characters)' };
      }
      
      // Check domain part
      if (domainPart.length === 0) {
        return { valid: false, message: 'Email is missing the domain part after @' };
      }
      
      // Check for dot in domain
      if (domainPart.indexOf('.') === -1) {
        return { valid: false, message: 'Email domain is missing a dot (e.g., example.com)' };
      }
      
      // Check for consecutive dots
      if (domainPart.indexOf('..') !== -1) {
        return { valid: false, message: 'Email domain cannot contain consecutive dots' };
      }
      
      // Check domain starts/ends with dot
      if (domainPart.startsWith('.')) {
        return { valid: false, message: 'Email domain cannot start with a dot' };
      }
      
      if (domainPart.endsWith('.')) {
        return { valid: false, message: 'Email domain cannot end with a dot' };
      }
      
      // Check for spaces
      if (trimmedEmail.indexOf(' ') !== -1) {
        return { valid: false, message: 'Email cannot contain spaces' };
      }
      
      // Check for valid characters in local part
      var validLocalChars = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
      if (!validLocalChars.test(localPart)) {
        return { valid: false, message: 'Email local part contains invalid characters' };
      }
      
      // STRICTER CHECK: Require at least one letter in local part
      if (!/[a-zA-Z]/.test(localPart)) {
        return { valid: false, message: 'Email local part must contain at least one letter' };
      }
      
      // Check for valid characters in domain part
      var validDomainChars = /^[a-zA-Z0-9.-]+$/;
      if (!validDomainChars.test(domainPart)) {
        return { valid: false, message: 'Email domain contains invalid characters' };
      }
      
      // Check domain has at least 2 characters after last dot
      var domainParts = domainPart.split('.');
      var lastPart = domainParts[domainParts.length - 1];
      if (lastPart.length < 2) {
        return { valid: false, message: 'Email domain extension is too short (e.g., .com, .org)' };
      }
      
      // Check for invalid domain patterns
      if (domainPart.match(/^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$/)) {
        // Allow IP addresses but still validate
        var ipParts = domainPart.split('.');
        if (ipParts.length === 4) {
          var allNumeric = ipParts.every(function(part) {
            var num = parseInt(part, 10);
            return !isNaN(num) && num >= 0 && num <= 255 && part === String(num);
          });
          if (!allNumeric) {
            return { valid: false, message: 'Invalid IP address format in email domain' };
          }
        }
      }
      
      // Final regex validation for well-formed email
      var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (!re.test(trimmedEmail)) {
        return { valid: false, message: 'Please enter a valid email address format' };
      }
      
      return { valid: true, message: '' };
    }

    function validatePhone(phone) {
      if (!phone || phone.trim() === '') {
        return { valid: false, message: 'Phone number is required' };
      }
      
      var digits = phone.replace(/\D/g, '');
      if (digits.length === 0) {
        return { valid: false, message: 'Please enter a valid phone number' };
      }
      
      if (digits.length < 10) {
        return { valid: false, message: 'Phone number must have at least 10 digits (entered ' + digits.length + ')' };
      }
      
      if (digits.length > 15) {
        return { valid: false, message: 'Phone number is too long (maximum 15 digits)' };
      }
      
      return { valid: true, message: '' };
    }

    // Enhanced validation for first name
    function validateFirstName(name) {
      if (!name || name.trim() === '') {
        return { valid: false, message: 'First name is required' };
      }
      
      var trimmed = name.trim();
      if (trimmed.length < 2) {
        return { valid: false, message: 'First name must be at least 2 characters (entered ' + trimmed.length + ')' };
      }
      
      if (trimmed.length > 50) {
        return { valid: false, message: 'First name is too long (maximum 50 characters)' };
      }
      
      // Check if name contains only letters, spaces, hyphens, and apostrophes
      if (!/^[a-zA-Z\s\-']+$/.test(trimmed)) {
        return { valid: false, message: 'First name can only contain letters, spaces, hyphens, and apostrophes' };
      }
      
      // Check for multiple consecutive spaces
      if (/\s{2,}/.test(trimmed)) {
        return { valid: false, message: 'First name cannot contain multiple consecutive spaces' };
      }
      
      // Check that it doesn't start or end with space
      if (trimmed.startsWith(' ') || trimmed.endsWith(' ')) {
        return { valid: false, message: 'First name cannot start or end with a space' };
      }
      
      return { valid: true, message: '' };
    }

    // Enhanced validation for last name
    function validateLastName(name) {
      if (!name || name.trim() === '') {
        return { valid: false, message: 'Last name is required' };
      }
      
      var trimmed = name.trim();
      if (trimmed.length < 2) {
        return { valid: false, message: 'Last name must be at least 2 characters (entered ' + trimmed.length + ')' };
      }
      
      if (trimmed.length > 50) {
        return { valid: false, message: 'Last name is too long (maximum 50 characters)' };
      }
      
      // Check if name contains only letters, spaces, hyphens, and apostrophes
      if (!/^[a-zA-Z\s\-']+$/.test(trimmed)) {
        return { valid: false, message: 'Last name can only contain letters, spaces, hyphens, and apostrophes' };
      }
      
      // Check for multiple consecutive spaces
      if (/\s{2,}/.test(trimmed)) {
        return { valid: false, message: 'Last name cannot contain multiple consecutive spaces' };
      }
      
      // Check that it doesn't start or end with space
      if (trimmed.startsWith(' ') || trimmed.endsWith(' ')) {
        return { valid: false, message: 'Last name cannot start or end with a space' };
      }
      
      return { valid: true, message: '' };
    }

    // Keep original validateName for backward compatibility
    function validateName(name) {
      if (!name || name.trim() === '') {
        return { valid: false, message: 'Name is required' };
      }
      
      var trimmed = name.trim();
      if (trimmed.length < 2) {
        return { valid: false, message: 'Name must be at least 2 characters (entered ' + trimmed.length + ')' };
      }
      
      if (trimmed.length > 100) {
        return { valid: false, message: 'Name is too long (maximum 100 characters)' };
      }
      
      // Check if name contains only letters, spaces, hyphens, and apostrophes
      if (!/^[a-zA-Z\s\-']+$/.test(trimmed)) {
        return { valid: false, message: 'Name can only contain letters, spaces, hyphens, and apostrophes' };
      }
      
      return { valid: true, message: '' };
    }

    function validateMessage(message) {
      if (!message || message.trim() === '') {
        return { valid: false, message: 'Message is required' };
      }
      
      var trimmed = message.trim();
      if (trimmed.length < 10) {
        return { valid: false, message: 'Message must be at least 10 characters (entered ' + trimmed.length + ')' };
      }
      
      if (trimmed.length > 5000) {
        return { valid: false, message: 'Message is too long (maximum 5000 characters)' };
      }
      
      return { valid: true, message: '' };
    }

    function validateSelect(value) {
      if (!value || value === '' || value === 'Select an inquiry type...') {
        return { valid: false, message: 'Please select an inquiry type' };
      }
      
      return { valid: true, message: '' };
    }

    function validateText(value, fieldName) {
      if (!value || value.trim() === '') {
        return { valid: false, message: fieldName + ' is required' };
      }
      
      return { valid: true, message: '' };
    }

    // Show error message
    function showError(field, message) {
      var fieldContainer = field.closest('.field');
      if (!fieldContainer) return;
      
      var errorContainer = fieldContainer.querySelector('.field-error-message');

      // Create error container if it doesn't exist
      if (!errorContainer) {
        createErrorContainer(field);
        errorContainer = fieldContainer.querySelector('.field-error-message');
      }

      field.classList.add('field-error');
      field.setAttribute('aria-invalid', 'true');
      if (errorContainer) {
        errorContainer.textContent = message;
        errorContainer.style.display = 'block';
      }
    }

    // Clear error message
    function clearError(field) {
      var fieldContainer = field.closest('.field');
      if (!fieldContainer) return;
      
      var errorContainer = fieldContainer.querySelector('.field-error-message');

      field.classList.remove('field-error');
      field.removeAttribute('aria-invalid');
      if (errorContainer) {
        errorContainer.textContent = '';
        errorContainer.style.display = 'none';
      }
    }

    // Validate single field
    function validateField(field) {
      var value = field.value;
      var validationType = field.getAttribute('data-validation');
      var errorMessage = field.getAttribute('data-error-message');
      var requiredMessage = field.getAttribute('data-required-message') || 'This field is required';
      var fieldLabel = field.getAttribute('data-label') || field.name || 'Field';
      var result;
      
      // Get the field's display name from label or placeholder
      var labelElement = field.closest('.field').querySelector('label');
      var fieldDisplayName = labelElement ? labelElement.textContent.trim() : fieldLabel;

      // Check if field is required and empty
      if (value === '' || value === null) {
        showError(field, fieldDisplayName + ' is required');
        return false;
      }

      switch (validationType) {
        case 'email':
          result = validateEmail(value);
          if (!result.valid) {
            // Use the specific error message from validation
            var emailErrorMessage = result.message;
            // Override with custom data attribute if provided
            if (errorMessage && result.valid === false) {
              // Only use custom message if it's a general validation error
              // For specific errors like "missing @" we want the specific message
              var isGenericError = errorMessage === 'Please enter a valid email address' || 
                                  errorMessage === 'Please enter a valid email';
              if (isGenericError) {
                // Use the specific validation message
                showError(field, emailErrorMessage);
              } else {
                showError(field, errorMessage);
              }
            } else {
              showError(field, emailErrorMessage);
            }
          }
          break;
          
        case 'phone':
          result = validatePhone(value);
          if (!result.valid) {
            var phoneErrorMessage = errorMessage || result.message;
            showError(field, phoneErrorMessage);
          }
          break;
          
        case 'first_name':
          result = validateFirstName(value);
          if (!result.valid) {
            var firstNameErrorMessage = errorMessage || result.message;
            showError(field, firstNameErrorMessage);
          }
          break;
          
        case 'last_name':
          result = validateLastName(value);
          if (!result.valid) {
            var lastNameErrorMessage = errorMessage || result.message;
            showError(field, lastNameErrorMessage);
          }
          break;
          
        case 'name':
          result = validateName(value);
          if (!result.valid) {
            var nameErrorMessage = errorMessage || result.message;
            showError(field, nameErrorMessage);
          }
          break;
          
        case 'message':
          result = validateMessage(value);
          if (!result.valid) {
            var messageErrorMessage = errorMessage || result.message;
            showError(field, messageErrorMessage);
          }
          break;
          
        case 'select':
          result = validateSelect(value);
          if (!result.valid) {
            var selectErrorMessage = errorMessage || result.message;
            showError(field, selectErrorMessage);
          }
          break;
          
        default:
          result = validateText(value, fieldDisplayName);
          if (!result.valid) {
            showError(field, result.message);
          }
      }

      if (result && result.valid) {
        clearError(field);
        return true;
      }

      return false;
    }

    // Validate all fields
    function validateAllFields() {
      var isValid = true;
      var fields = form.querySelectorAll('input[required], select[required], textarea[required]');

      fields.forEach(function (field) {
        // Ensure error container exists
        createErrorContainer(field);

        if (!validateField(field)) {
          isValid = false;
        }
      });

      return isValid;
    }

    // Get all required fields
    var requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');

    // Initialize error containers for all required fields
    requiredFields.forEach(function (field) {
      createErrorContainer(field);
    });

    // Focus out validation
    requiredFields.forEach(function (field) {
      field.addEventListener('blur', function () {
        validateField(this);
      });

      // Clear error on focus
      field.addEventListener('focus', function () {
        clearError(this);
      });

      // Real-time validation on input/change
      field.addEventListener('input', function () {
        if (this.classList.contains('field-error') || this.value.length > 0) {
          validateField(this);
        }
      });

      field.addEventListener('change', function () {
        if (this.classList.contains('field-error') || this.value.length > 0) {
          validateField(this);
        }
      });
    });

    // Form submission validation
    form.addEventListener('submit', function (e) {
      // Remove any existing validation error messages
      var existingError = document.getElementById('form-validation-error');
      if (existingError) {
        existingError.remove();
      }

      var isValid = validateAllFields();

      if (!isValid) {
        e.preventDefault();

        // Scroll to first error
        var firstError = document.querySelector('.field-error');
        if (firstError) {
          var field = firstError.closest('.field');
          if (field) {
            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstError.focus();
          }
        }

        // Show general error message dynamically
        var errorHtml = document.createElement('div');
        errorHtml.className = 'form-error';
        errorHtml.id = 'form-validation-error';
        errorHtml.innerHTML = '<p>' + generalErrorMessage + '</p>';
        form.prepend(errorHtml);

        return false;
      }

      // If validation passes, allow form to submit
      return true;
    });

    // Remove general error when user starts typing
    form.addEventListener(
      'focus',
      function (e) {
        if (e.target.matches('input, textarea, select')) {
          var generalError = document.getElementById('form-validation-error');
          if (generalError) {
            generalError.remove();
          }
        }
      },
      true
    );

    // console.log('Contact form validation ready - all fields are mandatory');
  }
})();